function CoreService() {
  this.scrollToTop = function() {
    jQuery('html, body').animate({ scrollTop: 0 }, 'fast');
  }
}

export default CoreService;



// WEBPACK FOOTER //
// ./js/containers/core/services/core.service.js